import SignUpDealerFormData from "./types/sign-up-dealer-form-data";
import SignUpDealerTokenPayload from "../../common/types/sign-up-dealer-token-payload";
import SignUpDealerDisabledFormFields from "./types/sign-up-dealer-disabled-form-fields";
import DealerAddParams from "../../../../../common/services/dealer/add/dealer-add-params";

const createSignUpRequest = (
  formData: SignUpDealerFormData,
  taxiCorporationId: string,
): DealerAddParams => ({
  firstName: formData.firstName.trim(),
  lastName: formData.lastName.trim(),
  phoneNumber: formData.mobile,
  alternativePhoneNumber: formData.alternativeMobile,
  email: formData.email.trim(),
  username: formData.username.trim(),
  password: formData.password,
  taxiCorporationUuid: taxiCorporationId,
});

const createFormData = (
  tokenPayload: SignUpDealerTokenPayload,
): SignUpDealerFormData => {
  return {
    email: tokenPayload.user_data.email ?? "",
    password: "",
    passwordRepeat: "",
    username: tokenPayload.user_data.username ?? "",
    firstName: tokenPayload.user_data.first_name ?? "",
    lastName: tokenPayload.user_data.last_name ?? "",
    mobile: {
      dialingCode: tokenPayload.user_data.mobile_primary_prefix ?? "",
      number: tokenPayload.user_data.mobile_primary ?? "",
    },
    alternativeMobile: {
      dialingCode: tokenPayload.user_data.mobile_secondary_prefix ?? "",
      number: tokenPayload.user_data.mobile_secondary ?? "",
    },
  };
};

const createDisabledFormFieldsConfig = (
  tokenPayload: SignUpDealerTokenPayload,
): SignUpDealerDisabledFormFields => {
  return {
    email: !!tokenPayload.user_data.email,
    firstName: !!tokenPayload.user_data.first_name,
    lastName: !!tokenPayload.user_data.last_name,
    username: !!tokenPayload.user_data.username,
    mobile:
      !!tokenPayload.user_data.mobile_primary_prefix &&
      !!tokenPayload.user_data.mobile_primary,
    alternativeMobile:
      !!tokenPayload.user_data.mobile_secondary_prefix &&
      !!tokenPayload.user_data.mobile_secondary,
  };
};

const signUpDealerFactory = {
  createFormData,
  createDisabledFormFieldsConfig,
  createSignUpRequest,
};

export default signUpDealerFactory;
